export default "__VITE_ASSET__BTeLPyu3__"